import { useQuery } from '@tanstack/react-query';
import clsx from 'clsx';
import parseHtmlToReact from 'html-react-parser';
import { memo } from 'react';

import { getWebContainerQuery } from '@queries/editorial';
import { withErrorBoundary } from '@shared/ErrorBoundary';
import { competitionCode } from '@utilities/WindowContext';

import * as styles from './style.module.scss';

const WEB_CONTAINER = `${competitionCode}.TICKETS.OFFICIALTICKETS`.toUpperCase();
const ThirdPartyTickets = () => {
  const { data: articles } = useQuery(getWebContainerQuery(WEB_CONTAINER));

  if (!articles?.length) return null;

  return (
    <div
      className={clsx({
        [styles.thirdpartyWrapper]: true,
        'pk-bg--elevation-03': true,
        'thirdparty-template-col': articles.length > 1,
      })}
    >
      {articles.map((article) => (
        <Article key={article.id} article={article} />
      ))}
    </div>
  );
};

const Article = ({ article }) => {
  const summary = article.document?._elements.find((elem) => elem._type === 'SUMMARY');

  return (
    <section className={clsx(styles.thirdpartyTickets, 'pk-d--flex pk-flex--column pk-align-items--center')}>
      <img className={clsx(styles.thirdpartyTicketsIcon)} src={article.imageUrl} alt='' />
      <div
        className={clsx(styles.thirdpartyTicketsTitle, 'pk-pb--m pk-font--comp-bold pk-font-size--xl pk-text--text-01')}
      >
        {article.title}
      </div>
      <div
        className={clsx(
          styles.thirdpartyTicketsText,
          'pk-font--base-regular pk-font-size--m pk-text--center pk-text--text-01',
        )}
      >
        {parseHtmlToReact(summary._html ?? '')}
      </div>
    </section>
  );
};

export default withErrorBoundary(memo(ThirdPartyTickets));
